import React, { PropTypes } from 'react';
import DataService from '../../lib/DataService';
import CurrentRoleStore from '../../stores/CurrentRoleStore';
import { Modal, Input, Select, message, Button } from 'antd';
import { Link, hashHistory } from 'react-router';

const Option = Select.Option;

export default class SchoolClassesManageIndexPage extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    this.state = {
      grades: [],
      graduatedArray: [],
      currentRole: CurrentRoleStore.getCurrentRole(),
      newClass: {},
      deleteClass: {},
      editClass: {},
      newGrade: {},
      modalType: '',
      loading: false,

      classGradesDetail: [],
      showGraduated: false
    };
    // bind this
    this.createClass = this.createClass.bind(this);
    this.inputNewClassName = this.inputNewClassName.bind(this);
    this.deleteClass = this.deleteClass.bind(this);
    this.editClass = this.editClass.bind(this);
    this.showDeleteClassModal = this.showDeleteClassModal.bind(this);
    this.showEditClassModal = this.showEditClassModal.bind(this);
    this.inputGradeNumber = this.inputGradeNumber.bind(this);
    this.inputEnrollmentYear = this.inputEnrollmentYear.bind(this);
    this.createGrade = this.createGrade.bind(this);
  }

  componentWillMount() {
    const schoolId = this.state.currentRole.associatName == 'school' ? this.state.currentRole.associatObj.id : this.state.currentRole.associatObj.schoolId
    if (this.state.currentRole.associatName == 'classRecord') {
      hashHistory.push(`school-admin/schools/${schoolId}/class-management/classes/${this.state.currentRole.associatObj.id}`);
    } else {
      // hard code
      DataService.getAllClassGrade(schoolId).then(response => {
        DataService.getAllClassesMember(schoolId).then(res => {
          response.map((grade) => {
            grade.classes = [];
            res.forEach((record) => {
              if (grade.id == record.class_grade_id) {
                grade.classes.push(record);
              }
            })
          })
          if (this.state.currentRole.associatName == 'classGrade') {
            response = response.filter((grade) => grade.id == this.state.currentRole.associatObj.id);
          }
          let graduatedArray  = response.filter((grade) => grade.is_graduated);
          let grades = response.filter((grade) => !grade.is_graduated);
          this.setState({
            grades,
            graduatedArray,
            classGradesDetail: res
          })
        }).then((err) => {
        });
      }).then((err) => {
      });
    }
  }

  componentDidMount(){
    CurrentRoleStore.addChangeListener(this.onRolesChange);
  }

  componentWillUnmount(){
    CurrentRoleStore.removeChangeListener(this.onRolesChange);
  }

  onCurrentRoleChange() {
    this.setState({
      currentRole: CurrentRoleStore.getCurrentRole()
    });
  }

  createClass() {
    let newClass = this.state.newClass;
    if (newClass.name) {
      this.setState({
        loading: true
      })
      DataService.createClass(newClass).then(res => {
        let grades = this.state.grades;

        grades.find((grade) => grade.id == res.class_grade_id).classes.push(res);

        this.setState({
          grades: grades,
          showModal: false,
          newClass: {},
          loading: false
        })
      }).catch((error) => {
        console.log(error)
        message.error('创建班级失败')
        this.setState({
          loading: false
        })
      })
    } else {
      message.info('请输入班级名称');
    }
  }

  inputNewClassName(e) {
    let newClass = this.state.modalType == 'add' ? this.state.newClass : this.state.editClass;
    let key = this.state.modalType == 'add' ? 'newClass' : 'editClass';
    newClass.name = e.target.value;
    this.setState({
      [key]: newClass
    })
  }

  deleteClass() {
    let { grade, classindex } = this.state.deleteClass;
    let grades = this.state.grades;
    this.setState({
      loading: true
    })
    DataService.deleteClass(grade.classes[classindex].id).then(res => {
      if (!res.errors) {
        grades.find((item) => item.id == grade.id).classes.splice(classindex, 1);

        this.setState({
          grades: grades,
          deleteClass: {},
          showModal: false,
          loading: false
        })
      }
    }).catch((error) => {
      console.log(error)
      message.error('删除班级失败！')
      this.setState({
        loading: false
      })
    })
  }

  editClass(e) {
    let { grade, classindex } = this.state.editClass;
    let grades = this.state.grades;
    let graduatedArray = this.state.graduatedArray;
    let gradesAll = grades.concat(graduatedArray);

    if (this.state.editClass.name) {
      this.setState({
        loading: true
      })
      DataService.updateClass(gradesAll[grade].classes[classindex].id, this.state.editClass.name).then(res => {
        gradesAll[grade].classes[classindex].name = this.state.editClass.name;
        grades = gradesAll.filter((grade) => !grade.is_graduated);
        graduatedArray = gradesAll.filter((grade) => grade.is_graduated);
        this.setState({
          grades: grades,
          graduatedArray: graduatedArray,
          editClass: {},
          showModal: false,
          loading: false
        })
      }).catch((error) => {
        message.error('更新班级信息失败，请重试');
        this.setState({
          loading: false
        })
      })
    } else {
      message.info('请输入班级名称');
    }
  }

  showDeleteClassModal(e) {
    let gradeId = e.currentTarget.dataset.grade, classindex = e.currentTarget.dataset.classindex;
    let grade = this.state.grades.find((grade) => grade.id == gradeId);

    this.setState({
      deleteClass: {
        grade: grade,
        classindex: classindex,
        name: grade.classes[classindex].name,
      },
      modalType: 'delete',
      showModal: true
    })
  }

  showEditClassModal(e) {
    let { gradeid, classindex } = e.currentTarget.dataset;
    let grades = this.state.grades.concat(this.state.graduatedArray);
    let grade = grades.findIndex(g => g.id == gradeid)

    this.setState({
      editClass: {
        grade: grade,
        classindex: classindex,
        name: grades[grade].classes[classindex].name,
      },
      modalType: 'edit',
      showModal: true
    })
  }

  inputGradeNumber(value) {
    this.state.newGrade.number = parseInt(value);
    this.setState({
      newGrade: this.state.newGrade
    });
  }

  inputEnrollmentYear(value) {
    this.state.newGrade.enrollment_year = parseInt(value);
    this.setState({
      newGrade: this.state.newGrade
    });
  }

  createGrade() {
    if (this.state.newGrade && this.state.newGrade.number && this.state.newGrade.enrollment_year) {
      this.setState({
        loading: true
      })
      let schoolId = this.state.currentRole.associatObj.id;
      DataService.createClassGrade(schoolId, this.state.newGrade).then((response) => {
        this.state.classGradesDetail.push(response);
        response.classes = []
        this.state.grades.push(response);
        this.setState({
          grades: this.state.grades,
          classGradesDetail: this.state.classGradesDetail,

          showModal: false,
          newGrade: {},
          loading: false
        })
      }).catch((error) => {
        console.log(error)
        this.setState({
          loading: false
        })
        if (error && error.errorMessage && error.errorMessage.errors[0].code == 51) {
          message.error('该年级已存在')
        } else {
          message.error('创建失败')
        }
      })
    } else {
      message.info('请选择年级名和入学年份')
    }
  }

  getGradesDetail() {
    let allGrades = [1, 2, 3, 4, 5], grades = this.state.grades;
    grades.forEach((item) => {
      let index = allGrades.findIndex((grade) => grade == item.number);
      if (index >= 0) {
        allGrades.splice(index, 1);
      }
    })
    return allGrades.length > 0 ? true : false
  }

  toolGraduatedDate(date) {
    return date ? (new Date(date).getFullYear() + '年') : ''
  }

  _modalView() {
    switch (this.state.modalType) {
      case 'add':
        return (
          <div>
            <div className="modal-title">添加班级</div>
            <Input addonBefore={<span><span className="red">*</span>班级名称</span>} onChange={this.inputNewClassName} value={this.state.newClass.name}/>
            <Button className="btn" onClick={this.createClass} loading={this.state.loading}>确认添加</Button>
          </div>
        )
      case 'edit':
        return (
          <div>
            <div className="modal-title">编辑班级信息</div>
            <Input addonBefore={<span><span className="red">*</span>班级名称</span>} onChange={this.inputNewClassName} value={this.state.editClass.name}/>
            <Button className="btn" onClick={this.editClass} loading={this.state.loading}>确认修改</Button>
          </div>
        )
      case 'delete':
        return (
          <div>
            <div className="modal-title">删除班级</div>
            <div className="text">确认删除{this.state.deleteClass.name}嘛？</div>
            <div className="btn-no-bg" onClick={this.deleteClass}>确认删除</div>
          </div>
        )
      case 'add-grade':
        let gradeNameMap = {1: "托班", 2: "小班", 3: "中班", 4: "大班", 5: "大大班"};
        let existGradeNumber = this.state.classGradesDetail.map(g => g.number);
        let availableGradeNumber = Object.keys(gradeNameMap).filter(function(e) {return existGradeNumber.indexOf(parseInt(e)) < 0});
        let thisYear = (new Date()).getFullYear();
        return (
          <div>
            <div className="modal-title">添加年级</div>
            <div className="form-line">
              <div className="select-label"><span className="red">*</span> 年级名</div>
              <Select value={this.state.newGrade.number ? this.state.newGrade.number.toString() : this.state.newGrade.number} onChange={this.inputGradeNumber} className="select-dom">
                {availableGradeNumber.map((gradeNumber) =>
                  <Option value={gradeNumber} key={gradeNumber}>{gradeNameMap[gradeNumber]}</Option>
                )}
              </Select>
            </div>
            <div className="form-line">
              <div className="select-label"><span className="red">*</span> 入学年份</div>
              <Select value={this.state.newGrade.enrollment_year ? this.state.newGrade.enrollment_year.toString() : this.state.newGrade.enrollment_year} onChange={this.inputEnrollmentYear} className="select-dom">
                {[0, -1, -2, -3, -4].map((yearDiff) =>
                  <Option value={(thisYear + yearDiff).toString()} key={yearDiff}>{thisYear + yearDiff}</Option>
                )}
              </Select>
            </div>
            <Button className="btn" onClick={this.createGrade} loading={this.state.loading} >确认添加</Button>
          </div>
        )
    }

  }

  render() {
    return (
      <div className="school-admin-classes-manage-index-page">
        <div className="container-title">
            {(this.state.currentRole.associatName == 'school' || this.state.currentRole.associatName == 'system') ? <Link className="import-students-btn" to={`school-admin/schools/${this.state.currentRole.associatObj.schoolId}/import-students`}>导入全部学生名单</Link> : ''}
        </div>
        <div className="grades-list">
          {this.state.grades.map(grade => {
            return <div className="grade-box" key={"grade-" + grade.id}>
              <div className="grade-name">{grade.grade_name}</div>
              {grade.classes.map((classItem, classIndex) => {
                return <div className="class-box" key={"class-" + classItem.id}>
                  <Link to={`school-admin/schools/${this.state.currentRole.associatName == 'school' ? this.state.currentRole.associatObj.id : this.state.currentRole.associatObj.schoolId}/class-management/classes/${classItem.id}`}>
                    <div className="class-content">
                      <div className="text-bg">{classItem.name}</div>
                      <div className="text-sm">老师：{(classItem.teachers && classItem.teachers.length != 0) ? classItem.teachers.join('、') : '0人'}</div>
                      <div className="text-sm">宝贝：{classItem.student_count || 0}人</div>
                    </div>
                  </Link>
                  <div className="edit-class-btn">
                    <div className="btn" data-gradeid={grade.id} data-classindex={classIndex} onClick={this.showEditClassModal}>编辑</div>
                    {((!classItem.teachers || classItem.teachers.length == 0) && !classItem.student_count) && <div className="btn delete-btn" data-grade={grade.id} data-classindex={classIndex} onClick={this.showDeleteClassModal}>删除</div>}
                  </div>
                </div>
              })}
              <div className="class-box">
                <div className="add-class" onClick={() => {this.setState({showModal: true, newClass: {grade_id: grade.id, name: ''}, modalType: 'add'})}}>+添加班级</div>
              </div>
            </div>
          })}
          {this.getGradesDetail() && this.state.currentRole && (this.state.currentRole.associatName == 'school' ||  this.state.currentRole.associatName == 'system') &&
            <div className="add-grade" onClick={() => {this.setState({showModal: true, newGrade: {number: null, enrollment_year: null}, modalType: 'add-grade'})}}>
              <div className="text">+创建年级</div>
            </div>
          }
        </div>
        <div style={{ color: '#4DA1FF', marginBottom: '20px', cursor: 'pointer' }} onClick={() => this.setState({ showGraduated: !this.state.showGraduated })}>{this.state.showGraduated ? '收起' : '查看'}毕业班级</div>
        <div className="grades-list">
          {this.state.showGraduated && this.state.graduatedArray.map(grade => {
            return <div className="grade-box" key={"grade-" + grade.id}>
              <div className="grade-name">{grade.grade_name} - {this.toolGraduatedDate(grade.graduate_date)}毕业</div>
              {grade.classes.map((classItem, classIndex) => {
                return <div className="class-box" key={"class-" + classItem.id}>
                  <Link to={`school-admin/schools/${this.state.currentRole.associatName == 'school' ? this.state.currentRole.associatObj.id : this.state.currentRole.associatObj.schoolId}/class-management/classes/${classItem.id}`}>
                    <div className="class-content">
                      <div className="text-bg">{classItem.name}</div>
                      <div className="text-sm">老师：{(classItem.teachers && classItem.teachers.length != 0) ? classItem.teachers.join('、') : '0人'}</div>
                      <div className="text-sm">宝贝：{classItem.student_count || 0}人</div>
                    </div>
                  </Link>
                  <div className="edit-class-btn">
                    <div className="btn" data-gradeid={grade.id} data-classindex={classIndex} onClick={this.showEditClassModal}>编辑</div>
                    {((!classItem.teachers || classItem.teachers.length == 0) && !classItem.student_count) && <div className="btn delete-btn" data-grade={grade.id} data-classindex={classIndex} onClick={this.showDeleteClassModal}>删除</div>}
                  </div>
                </div>
              })}
            </div>
          })}
        </div>
        <Modal
          className="class-manage-add-class-modal"
          footer={null}
          title={null}
          onCancel={() => this.setState({showModal: false, newClass: {}, deleteClass: {}, editClass: {}, newGrade: {}})}
          visible={this.state.showModal}
        >
          {this._modalView()}
        </Modal>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/schooladmin/SchoolClassesManageIndexPage.jsx